<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    게시글 신고관리
                </div>
                <div class="">
                    <declaration-list-component :declarationType="'board'"></declaration-list-component>
                </div>
            </div>
        </div>
        <declaration-detail-modal></declaration-detail-modal>
        <declaration-status-modal></declaration-status-modal>
    </div>
</template>

<script>
import DeclarationListComponent from "@/components/declaration/DeclarationListComponent";
import DeclarationDetailModal from "../../components/modal/DeclarationDetailModal";
import DeclarationStatusModal from "../../components/modal/DeclarationStatusModal";

export default {
    name: "DeclarationBoard",
    mixins: [],
    components: {DeclarationStatusModal, DeclarationDetailModal, DeclarationListComponent},
    provide() {
        return {}
    },
    props: {},
    data() {
        return {}
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {},
    watch: {},
}
</script>

<style lang="scss">
</style>